module.exports = __webpack_public_path__ + "assets/img/cynosure-academy-banner.f84ef703.png";